import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation CreateFormFieldVisibilityRule(
    $formFieldId: Int!
    $formId: Int!
    $answerToMatch: String!
    $chainingComparison: String!
    $comparison: String!
    $order: Int!
    $targetFormFieldId: Int!
  ) {
    createRegistrationFormFieldVisibilityRule(
      formFieldId: $formFieldId
      formId: $formId
      input: {
        answerToMatch: $answerToMatch
        chainingComparison: $chainingComparison
        comparison: $comparison
        order: $order
        targetFormFieldId: $targetFormFieldId
      }
    ) {
      answerToMatch
      chainingComparison
      comparison
      formFieldId
      id
      order
      targetFormFieldId
    }
  }
`;
